import { useState } from 'react';
import { supportedLanguagesWithVoices } from 'flow/types/CreateSoundTypes';
import { getSpokenLanguage } from 'flow/utils/browser-utils';

const languageMapping: Record<string, string> = {
    sv: 'sv-SE',
    da: 'da-DK',
    nb: 'nb-NO',
    fi: 'fi-FI',
    ca: 'ca-ES',
    en: 'en-GB',
    'fr-FR': 'fr-FR',
    'es-419': 'es-US',
    'es-ES': 'es-ES',
    'nl-BE': 'nl-BE',
    'nl-NL': 'nl-NL',
    'pt-PT': 'pt-PT',
    'pt-BR': 'pt-BR',
    'it-IT': 'it-IT',
    'de-DE': 'de-DE',
    ar: 'ar-AE',
};

export const useLanguageSelection = () => {
    const applicationLanguage = getSpokenLanguage();

    const getMatchingTTSLanguage = (appLangCode: string) => {
        if (languageMapping[appLangCode]) {
            return languageMapping[appLangCode];
        }

        const matchingLanguage = supportedLanguagesWithVoices.find((lang) =>
            lang.code.startsWith(appLangCode + '-'),
        );

        return matchingLanguage?.code || null;
    };

    const getInitialLanguageCode = () => {
        if (applicationLanguage) {
            const matchedTTSLanguage =
                getMatchingTTSLanguage(applicationLanguage);
            if (matchedTTSLanguage) {
                return matchedTTSLanguage;
            }
        }
        return 'en-GB';
    };

    const [languageCode, setLanguageCode] = useState(getInitialLanguageCode());

    const currentLanguage = supportedLanguagesWithVoices.find(
        (lang) => lang.code === languageCode,
    );

    return {
        languageCode,
        setLanguageCode,
        currentLanguage,
        supportedLanguages: supportedLanguagesWithVoices,
    };
};
